import React, { useEffect, useRef, useState } from "react";
import {
  allStatusConfig,
  ConfigData,
  DefaulSorting,
} from "./configData";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import SearchIcon from "../../../assets/header/search.svg";
import FilterIcon from "../../../assets/header/filter.svg";
import RefreshIcon from "../../../assets/header/refresh.svg";
import { Reusable_table } from "../../../components/reusableItems/table";
import * as XLSX from 'xlsx';

import "./staff_referral.css";
import { useLocation, useNavigate } from "react-router";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Filter } from "./filter";
import { fetchAllStaffReferralList, fetchStaffReferralExportList, updateStaffReferralStatus } from "../../../store/staff_referral";
import ExportIcon from "../../../assets/header/export.svg";
import { Search } from "./search";
import { HR_CONNECT_STAFF_REFERRAL_DETAILS } from "../../../routes";
import { ShowStatusUpdateDialog } from "./statusUpdateDialog";
import momentTZ from 'moment-timezone';

const STAFF_REFERRAL_TAB = {
  STAFF_REFERRAL_BUS: "Bus",
  STAFF_REFERRAL_RAIL: "Rail",
};

export const StaffReferralListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const exportLink = useRef(null);
  const query = new URLSearchParams(searchQuery);
  const { loading, staff_referral_list } = useSelector((state) => state.staffReferral);
  const [staffReferralTab, setStaffReferralTab] = useState(STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS);

  const [tempStatus, setTempStatus] = useState("");
  const [showStatus, setShowStatus] = useState(false);

  const [tempId, setTempId] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [tempData, setTempData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [searchValue, setSearchValue] = useState({
    name: "",
    contact_no: "",
    submitter_name: "",
  });

  const [filterValue, setFilterValue] = useState({
    updated_on_start: "",
    updated_on_end: "",
    updatedDate: "all",
    applied_on_start: "",
    applied_on_end: "",
    appliedDate: "all",
    status: [],
    position: '',
    type: 'bus',
  });


  const { designations } = useSelector((state) => state.designation);

  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "hr_connect.access_staff_referral"
  );

  const getData = async (callback) => {
    let payload = {
      applied_on_start: filterValue.appliedDate === 'all' ? '' : filterValue.applied_on_start,
      applied_on_end: filterValue.appliedDate === 'all' ? '' : filterValue.applied_on_end,
      updated_on_start: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_start,
      updated_on_end: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_end,
      status: encodeURIComponent(filterValue.status.join(',')),
      position: encodeURIComponent(filterValue.position),
      type: filterValue.type,
      submitter: encodeURIComponent(searchValue.submitter_name),
      name: encodeURIComponent(searchValue.name),
      contact_no: searchValue.contact_no,
    };
    const hasFilterValue =
      !!filterValue.applied_on_start ||
      !!filterValue.applied_on_end ||
      !!filterValue.updated_on_start ||
      !!filterValue.updated_on_end ||
      (Array.isArray(filterValue.status) && filterValue.status.length > 0) ||
      !!filterValue.position ||
      !!searchValue.submitter_name ||
      !!searchValue.name ||
      !!searchValue.contact_no;

    if (!hasFilterValue) {
      payload = {
        type: staffReferralTab === STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? "bus" : "rail"
      }
    }


    dispatch(fetchAllStaffReferralList(payload)).then((res) => {
      if (res.payload.status_code === 200) {
        setTempData(res.payload.data);
        setShouldFetch(false);
      } else {
        setShouldFetch(false);
        alert(res.payload.Message);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);


  const RefreshData = () => {
    getData();
  };

  const handleFilterAction = () => {
    setShowFilter(!showFilter);
  };

  const handleSearchAction = () => {
    setShowSearch(!showSearch);
  };


  const exportToXlsx = async () => {
    setExportLoading(true);
    let payload = {
      type: staffReferralTab === STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? "bus" : "rail",
      applied_on_start: filterValue.appliedDate === 'all' ? '' : filterValue.applied_on_start,
      applied_on_end: filterValue.appliedDate === 'all' ? '' : filterValue.applied_on_end,
      updated_on_start: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_start,
      updated_on_end: filterValue.updatedDate === 'all' ? '' : filterValue.updated_on_end,
      status: encodeURIComponent(filterValue.status.join(',')),
      position: encodeURIComponent(filterValue.position),
      submitter: encodeURIComponent(searchValue.submitter_name),
      name: encodeURIComponent(searchValue.name),
      contact_no: searchValue.contact_no,
    }
    dispatch(fetchStaffReferralExportList(payload)).then((res) => {

      const rawData = res.payload.data;

      // Function to detect ISO 8601 date string
      const isIsoDateString = (value) =>
        typeof value === "string" &&
        /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);

      // Convert dates inside the array
      const convertDates = (arr) =>
        arr.map((row) =>
          Array.isArray(row)
            ? row.map((cell) =>
              isIsoDateString(cell)
                ? momentTZ(cell).tz("Asia/Singapore").format("DD MMM YYYY, hh:mm A")
                : cell
            )
            : row
        );

      // Convert final data
      const finalData = convertDates(rawData);

      const worksheet = XLSX.utils.aoa_to_sheet(finalData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Referral List");
      XLSX.writeFile(workbook, "Staff_Referral_List.xlsx");
      setExportLoading(false);

    });
  };

  const handleExportAction = () => {
    exportToXlsx();
  };



  const icons = [
    {
      icon: FilterIcon,
      title: "Filter",
      action: handleFilterAction,
    },
    {
      icon: ExportIcon,
      title: "Export",
      action: handleExportAction,
    },
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    {
      icon: SearchIcon,
      title: "Search",
      action: handleSearchAction,
    },
  ];


  const handleTableClick = (type, id) => {
    console.log(type, id);
    if (type === "View Details") {
      navigate(`${HR_CONNECT_STAFF_REFERRAL_DETAILS}?id=${id}`)
    }
    if (type === "Update Status") {
      setTempId(id);
      const filteredData = tempData.filter(item => item.id === id);
      let status = allStatusConfig.filter(status => status.name.toLocaleLowerCase() === filteredData[0]?.status.toLocaleLowerCase())
      setTempStatus(status[0]);
      setShowStatus(true);
    }

  };

  const updateStatus = () => {
    setShowStatus(false);
    let params = {
      id: tempId,
      status: tempStatus.id,
    };
    dispatch(
      updateStaffReferralStatus({ data: params, id: tempId })
    ).then((res) => {
      if (res.payload.status_code === 200) {
        setTempStatus("");
        setTempId("");
        getData();
      } else {
        alert(res.payload.message);
      }
    });
  };


  const FilterAction = () => {
    setShowFilter(false);

    setSearchValue({
      name: "",
      contact_no: "",
      submitter_name: "",
    })

    if (filterValue.type === 'bus') {
      setStaffReferralTab(STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS);

    } else {
      setStaffReferralTab(STAFF_REFERRAL_TAB.STAFF_REFERRAL_RAIL);
    }
    setShouldFetch(true);

    getData();
  };

  const filterClearAction = async () => {
    setShowFilter(false);
    setFilterValue({
      ...filterValue,
      updated_on_start: "",
      updated_on_end: "",
      updatedDate: "all",
      applied_on_start: "",
      applied_on_end: "",
      appliedDate: "all",
      status: [],
      position: '',
      type: staffReferralTab == STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? 'bus' : 'rail',
    });

    setShouldFetch(true);
  };

  const SearchAction = () => {
    setShowSearch(false);

    setFilterValue({
      ...filterValue,
      updated_on_start: "",
      updated_on_end: "",
      updatedDate: "all",
      applied_on_start: "",
      applied_on_end: "",
      appliedDate: "all",
      status: [],
      position: '',
      type: staffReferralTab == STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? 'bus' : 'rail',
    });

    setShouldFetch(true);
  };


  useEffect(() => {
    if (shouldFetch) {
      getData();
      setShouldFetch(false);
    }
  }, [filterValue, shouldFetch]);


  const onTabChange = (tab) => {
    setStaffReferralTab(tab);
    setSearchValue({
      ...searchValue,
      name: "",
      contact_no: "",
      submitter_name: "",
    });
    setFilterValue({
      ...filterValue,
      updated_on_start: "",
      updated_on_end: "",
      updatedDate: "all",
      applied_on_start: "",
      applied_on_end: "",
      appliedDate: "all",
      status: [],
      position: '',
      type: staffReferralTab == STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? 'bus' : 'rail',
    });
    setShouldFetch(true);
  };

  function getStatusById(id) {
    return allStatusConfig.find(status => status.id === id);
  }

  function getStatusList(temp) {
    if (temp.id === "notsuitable" || temp.id === "withdraw") {
      return [];
    }

    if (temp.id === "offered&accepted") {
      return [getStatusById('completed'), getStatusById('withdraw')];
    }

    if (temp.id === "shortlistedforinterview") {
      return [getStatusById('offered&accepted'), getStatusById('withdraw')];
    }

    if (temp.id === "submitted") {
      return [getStatusById('shortlistedforinterview'), getStatusById('notsuitable')];
    }
    return [];
  }

  return (
    <>
      {viewPermssion ? (
        <div className="container">
          <div className="reusable_header_main_box">
            <div className="reusable_header_title">Staff Referral</div>
            <div className="reusable_header_icon_main_box">
              {icons.map((i, id) => {
                if (i.buttonName) {
                  return (
                    <div
                      key={id}
                      className="reusable_header_create_box"
                      onClick={i.action}
                    >
                      {i.buttonName}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={id}
                      className="reusable_header_icon_box"
                      onClick={i.action}
                    >
                      <img src={i.icon} />
                    </div>
                  );
                }
              })}
            </div>
          </div>

          {showStatus && (
            <ShowStatusUpdateDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={getStatusList(tempStatus)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}


          {showFilter && (
            <Filter
              setShowFilter={setShowFilter}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              FilterAction={FilterAction}
              filterClearAction={filterClearAction}
            />
          )}

          {showSearch && (
            <Search
              setShowFilter={setShowSearch}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              SearchAction={SearchAction}
            />
          )}


          {exportLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100vh - 165px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}


          {loading || searchLoading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100vh - 165px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <>
              <div className="flex-between">
                <div className="staff_referral_content">
                  <div className="tabs">
                    <div
                      onClick={() => onTabChange(STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS)}
                      className={`tab ${staffReferralTab === STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS ? "isactive" : ""
                        }`}
                    >
                      {STAFF_REFERRAL_TAB.STAFF_REFERRAL_BUS}
                    </div>
                    <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                    <div
                      onClick={() => onTabChange(STAFF_REFERRAL_TAB.STAFF_REFERRAL_RAIL)}
                      className={`tab ${staffReferralTab === STAFF_REFERRAL_TAB.STAFF_REFERRAL_RAIL ? "isactive" : ""
                        }`}
                    >
                      {STAFF_REFERRAL_TAB.STAFF_REFERRAL_RAIL}
                    </div>

                  </div>

                </div>

              </div>

              <Reusable_table
                key={tempData.map(i => i.status).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                defaultSorting={DefaulSorting}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={
                  "calc(100vh - 220px)"
                }
                maxWidth={"calc(100vw - 240px)"}
              />
            </>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
